import { createContext } from "react";

import type { EpochId, GridEpochId } from "@apis/calorie-grid/models";

export interface ConfigContextValue {
  readonly epochId: EpochId;
  readonly gridEpochId: GridEpochId;
  readonly squareKcal: number;
}

export const ConfigContext = createContext<ConfigContextValue | null>(null);
